export const getWhatsAppLink = (phone?: string) => {
  if (!phone) return null;

  // Remove +, spaces, -, (), etc → keep only digits
  const cleaned = phone.replace(/\D/g, "");

  // WhatsApp requires country code + number
  // Most international numbers are 10–15 digits
  if (cleaned.length < 10 || cleaned.length > 15) {
    return null;
  }

  return `https://wa.me/${cleaned}`;
};

/** Opens WhatsApp so the organiser picks the contact — no server-side WhatsApp API. */
export const buildWhatsAppShareHref = (message: string) =>
  `https://wa.me/?text=${encodeURIComponent(message)}`;

/** One-line label for organiser UI; copy/WhatsApp still use the full URL. */
export const shortenPayUrlForDisplay = (link: string): string => {
  const raw = (link || "").trim();
  if (!raw) return "";

  try {
    const url = new URL(raw);
    const segments = url.pathname.replace(/\/+$/, "").split("/").filter(Boolean);
    const token = segments.pop() || "";
    const prefix = segments.length ? `/${segments.join("/")}/` : "/";
    const shortToken = token.length > 10 ? `${token.slice(0, 8)}…` : token;
    return `${url.host}${prefix}${shortToken}`;
  } catch {
    return raw.length > 42 ? `${raw.slice(0, 39)}…` : raw;
  }
};

export const buildReceiveMoneyWhatsAppMessage = (
  beneficiaryName: string,
  link: string
) => {
  const name = (beneficiaryName || "").trim() || "Someone";
  const payLink = (link || "").trim();
  // One URL in the payload — WhatsApp builds the link preview from it.
  // Avoid "Payment request: {url}" plus the same url again on the next line.
  return payLink
    ? `Payment request from ${name}.\n${payLink}`
    : `Payment request from ${name}.`;
};

export const buildReceiveMoneyWhatsAppShareHref = (
  link: string,
  beneficiaryName?: string
) =>
  buildWhatsAppShareHref(
    buildReceiveMoneyWhatsAppMessage(beneficiaryName || "", link)
  );

/** Same-tab navigation — target=_blank on wa.me can open WhatsApp twice on mobile. */
export const openReceiveMoneyWhatsAppShare = (
  link: string,
  beneficiaryName?: string
) => {
  const href = buildReceiveMoneyWhatsAppShareHref(link, beneficiaryName);
  window.location.assign(href);
};
